"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es7.object.get-own-property-descriptors");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("core-js/modules/es6.array.find");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.regexp.split");

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuexClass = require("vuex-class");

var _vuePropertyDecorator = require("vue-property-decorator");

var _elementUi = require("element-ui");

var _request = require("@/services/request/request.service");

var _helper = require("@/mixins/helper/helper");

var _logger = require("@/mixins/logger/logger");

var _loading = require("@/mixins/loading/loading");

var _permission = require("@/mixins/permission/permission");

var _autoLogout = require("@/mixins/auto-logout/auto-logout");

var _mapWorld = _interopRequireDefault(require("@/components/map-world/map-world.vue"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ZoneV2Component = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(ZoneV2Component, _Mixins);

  var _super = _createSuper(ZoneV2Component);

  function ZoneV2Component() {
    var _this;

    (0, _classCallCheck2.default)(this, ZoneV2Component);
    _this = _super.apply(this, arguments);
    _this.requestParameters = {};
    _this.formData = {
      code: null,
      name: null,
      description: null,
      country: null,
      company: null
    };
    _this.publicPath = process.env.BASE_URL;
    _this.numberOfZone = 1;
    _this.dataSet = null;
    _this.locations = {};
    _this.locationId = '';
    _this.locationData = {};
    _this.projectCodeId = '';
    _this.copyProjectCodeId = '';
    _this.projectCodes = [];
    _this.locationList = [];
    _this.allLocationList = [];
    _this.uploadLocationData = {};
    _this.uploadLocationList = [];
    _this.insertZoneModal = false;
    _this.uploadZoneModal = false;
    _this.updateZoneModal = false;
    _this.copyZoneModal = false;
    _this.isWellcome = false;
    _this.isPns = false;
    return _this;
  }

  (0, _createClass2.default)(ZoneV2Component, [{
    key: "beforeCreate",
    value: function beforeCreate() {
      if (!this.request) {
        this.request = new _request.Request('application/json', process.env.VUE_APP_SECRET_KEY_HASH);
      }

      if (!this.requestFile) {
        this.requestFile = new _request.Request('multipart/form-data', process.env.VUE_APP_SECRET_KEY_HASH);
      }
    }
  }, {
    key: "created",
    value: function created() {
      this.loading = true;
      this.requestParameters['limit'] = 999;

      if (!this.requestLegacy) {
        this.requestLegacy = new _request.Request('application/json', this.$lfToken || null);
      }

      this.locations = {
        latitude: this.$userData.latlng.split(',')[0],
        longitude: this.$userData.latlng.split(',')[1]
      };
      this.requestParameters[process.env.VUE_APP_CUSTOMER_KEY] = this.$userInformation.customerKey || '';

      if (this.$userInformation.company) {
        this.formData['country'] = this.$userInformation.company.country ? this.$userInformation.company.country.replace(/\s/g, '').toLowerCase() : '';
        this.formData['company'] = this.$userInformation.company.name ? this.$userInformation.company.name.replace(/\s/g, '').toLowerCase() : '';
      }

      this.loadCoreInformation();
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.isWellcome = this.$userSetting['default30'] === 'wellcome';
      this.isPns = this.$userSetting['default30'] === 'pns';
    }
  }, {
    key: "loadCoreInformation",
    value: function loadCoreInformation() {
      var _this2 = this;

      return this.requestLegacy.get('LEGACY_CORE', 'projectcodes', this.requestParameters).then(function (projectcodes) {
        if (projectcodes.failed) {
          return Promise.reject('');
        }

        _this2.projectCodes = projectcodes.data || [];
        _this2.loading = false;
      }).catch(function (error) {
        _this2.projectCodes = [];
        _this2.loading = false;
      });
    }
  }, {
    key: "onChangeLocation",
    value: function onChangeLocation() {
      this.refreshMap();
    }
  }, {
    key: "onChangeProjectCodes",
    value: function onChangeProjectCodes() {
      this.locationId = '';
      this.locationList = [];
      this.uploadLocationList = [];
      this.numberOfZone = 1;
      this.dataSet = null;
      this.refreshMap();
    }
  }, {
    key: "onDataSetChanges",
    value: function onDataSetChanges() {
      var file = this.$refs.dataSet;

      if (typeof file !== 'undefined') {
        this.dataSet = file.files[0];
      }
    }
  }, {
    key: "updateZone",
    value: function updateZone() {
      var _this3 = this;

      var mapWorld = this.$refs.mapWorld;

      if (typeof mapWorld !== 'undefined' && mapWorld.hasRectangles && mapWorld.rectangles.length >= 1 && this.helper.isNotEmpty(this.projectCodeId) && this.helper.isNotEmpty(this.locationId)) {
        var polygonBounds = mapWorld.rectangles[0].getPath();
        var wayPoints = [];

        for (var i = 0; i < polygonBounds.length; i++) {
          wayPoints.push(polygonBounds.getAt(i).lat() + ',' + polygonBounds.getAt(i).lng());
        }

        if (wayPoints.length >= 3) {
          this.request.put('AI_ROUTE', "zoning/".concat(this.locationId), this.requestParameters, {
            wayPoints: wayPoints
          }).then(function (data) {
            if (data.failed) {
              return Promise.reject(data.message || '');
            }

            var message = {
              title: _this3.$i18n.t('notification.zone.updateSuccess'),
              duration: 5000
            };

            _elementUi.Notification.success(message);

            _this3.clearRoutingCache();
          }).catch(function (error) {
            var message = {
              title: _this3.$i18n.t('notification.zone.error'),
              duration: 5000
            };

            _elementUi.Notification.error(message);
          });
        } else {
          var message = {
            title: this.$i18n.t('notification.zone.updateFailed'),
            duration: 5000
          };

          _elementUi.Notification.success(message);
        }
      }
    }
  }, {
    key: "deleteZone",
    value: function deleteZone() {
      var _this4 = this;

      _elementUi.MessageBox.confirm("".concat(this.$i18n.t('zone.deleteZoneText'), " \"").concat(this.locationData['code'], "\""), 'Warning', {
        confirmButtonText: this.$i18n.t('general.delete'),
        cancelButtonText: this.$i18n.t('general.cancel'),
        type: 'warning',
        center: true
      }).then(function () {
        var mapWorld = _this4.$refs.mapWorld;

        if (typeof mapWorld !== 'undefined' && _this4.helper.isNotEmpty(_this4.projectCodeId) && _this4.helper.isNotEmpty(_this4.locationId)) {
          _this4.request.delete('AI_ROUTE', "zoning/".concat(_this4.locationId), _this4.requestParameters).then(function (data) {
            if (data.failed) {
              return Promise.reject(data.message || '');
            }

            _this4.onChangeProjectCodes();

            var message = {
              title: _this4.$i18n.t('notification.zone.deleteSuccess'),
              duration: 5000
            };

            _elementUi.Notification.success(message);

            _this4.clearRoutingCache();
          }).catch(function (error) {
            var message = {
              title: _this4.helper.toString(error),
              duration: 5000
            };

            _elementUi.Notification.error(message);
          });
        }
      });
    }
  }, {
    key: "submitForm",
    value: function submitForm() {
      var _this5 = this;

      var mapWorld = this.$refs.mapWorld;

      if (typeof mapWorld !== 'undefined' && this.helper.isNotEmpty(this.projectCodeId)) {
        var cleanData = this.cleanFormData(this.formData);
        var duplicateLocation = this.locationList.find(function (lData) {
          return lData['code'] === cleanData['code'];
        });

        if (duplicateLocation) {
          var message = {
            title: this.$i18n.t('notification.zone.duplicateCode'),
            duration: 5000
          };

          _elementUi.Notification.error(message);

          return;
        }

        this.logger.info("one form submitted: ".concat(JSON.stringify(cleanData)));
        this.request.post('AI_ROUTE', "zoning", this.requestParameters, cleanData).then(function (data) {
          if (data.failed) {
            return Promise.reject(data.message || '');
          }

          _this5.formData['code'] = null;
          _this5.formData['name'] = null;
          _this5.formData['description'] = null;

          _this5.onChangeProjectCodes();

          _this5.insertZoneModal = false;
          var message = {
            title: _this5.$i18n.t('notification.zone.insertSuccess'),
            duration: 5000
          };

          _elementUi.Notification.success(message);

          _this5.clearRoutingCache();
        }).catch(function (error) {
          var message = {
            title: _this5.helper.toString(error),
            duration: 5000
          };

          _elementUi.Notification.error(message);
        });
      }
    }
  }, {
    key: "cleanFormData",
    value: function cleanFormData() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.helper.cleanDataRemoveNull({
        project: this.projectCodeId,
        code: data['code'].toUpperCase(),
        name: data['name'] || '',
        description: data['description'] || '',
        color: this.helper.randomColor,
        hashCodes: [],
        wayPoints: []
      });
    }
  }, {
    key: "zoneUpload",
    value: function zoneUpload() {
      var _this6 = this;

      var mapWorld = this.$refs.mapWorldUpload;

      if (this.helper.isNotEmpty(this.projectCodeId) && typeof mapWorld !== 'undefined') {
        var formData = new FormData();
        formData.append('projectCode', this.projectCodeId);

        if (this.dataSet && this.dataSet.constructor.name === 'File') {
          formData.append('data', this.dataSet);
        }

        var importUrl = 'v1/core/zone/import'; // HACK: for wellcome pns

        if (this.isWellcome) {
          importUrl = 'v1/core/zone/import/wellcome';
        }

        if (this.isPns) {
          importUrl = 'v1/core/zone/import/pns';
        }

        this.requestFile.post('ROUTING', importUrl, this.requestParameters, formData).then(function (data) {
          if (data.failed) {
            return Promise.reject(data.message || '');
          }

          _this6.uploadLocationData = data['data'] || {};
          _this6.uploadLocationList = data['data']['zones'] ? data['data']['zones'].map(function (zData) {
            return {
              color: zData['color'] || '#ffffff',
              wayPoints: zData['wayPoints'].map(function (wpData) {
                return {
                  waypoint: wpData,
                  address: ''
                };
              })
            };
          }) : [];
          mapWorld.initAllPolygon(_this6.uploadLocationList, true);
        }).catch(function (error) {
          var message = {
            title: _this6.helper.toString(error),
            duration: 5000
          };

          _elementUi.Notification.error(message);
        }); // const zoneList = [];
        // for (let index = 0; index < this.numberOfZone; index++) {
        // 	zoneList.push(this.helper.randomColor);
        // }
        // formData.append('project', this.projectCodeId);
        // formData.append('zones', this.helper.toString(zoneList));
        // formData.append('latitudeIndex', '1');
        // formData.append('longitudeIndex', '2');
        // if (this.dataSet && this.dataSet.constructor.name === 'File') {
        // 	formData.append('dataSet', this.dataSet);
        // }
        // this.requestFile
        // 	.put('AI_ROUTE_V2', 'zoning', this.requestParameters, formData)
        // 	.then((data) => {
        // 		if (data.failed) {
        // 			return Promise.reject(data.message || '');
        // 		}
        // 		this.uploadLocationData = { projectCode: this.projectCodeId, zones: data['data'] || [] };
        // 		this.uploadLocationList = data['data'] || [];
        // 		mapWorld.initAllPolygon(this.uploadLocationList, true);
        // 	})
        // 	.catch((error) => {
        // 		const message: ElNotificationOptions = {
        // 			title: this.helper.toString(error),
        // 			duration: 5000,
        // 		} as ElNotificationOptions;
        // 		Notification.error(message);
        // 	});
      }
    }
  }, {
    key: "submitZoneUpload",
    value: function submitZoneUpload() {
      var _this7 = this;

      if (this.helper.isNotEmpty(this.projectCodeId) && this.uploadLocationList && this.uploadLocationList.length >= 1) {
        var cleanData = this.uploadLocationData;
        this.logger.info("form submitted: ".concat(JSON.stringify(cleanData)));
        this.request.post('ROUTING', 'v1/core/zone', _objectSpread({}, this.requestParameters), cleanData).then(function (data) {
          if (data.failed) {
            return Promise.reject(data.message || '');
          }

          _this7.onChangeProjectCodes();

          _this7.uploadZoneModal = false;
          var message = {
            title: _this7.$i18n.t('notification.zone.updateSuccess'),
            duration: 5000
          };

          _elementUi.Notification.success(message);
        }).catch(function (error) {
          var message = {
            title: _this7.helper.toString(error),
            duration: 5000
          };

          _elementUi.Notification.error(message);
        }); // const cleanData: object = this.cleanZoneUpload(this.uploadLocationList);
        // this.logger.info(`form submitted: ${JSON.stringify(cleanData)}`);
        // this.request
        // 	.post('AI_ROUTE_V2', 'zoning', { ...this.requestParameters, storeLocation: !!this.dataSet }, cleanData)
        // 	.then((data) => {
        // 		if (data.failed) {
        // 			return Promise.reject(data.message || '');
        // 		}
        // 		this.onChangeProjectCodes();
        // 		this.uploadZoneModal = false;
        // 		const message: ElNotificationOptions = {
        // 			title: this.$i18n.t('notification.zone.updateSuccess'),
        // 			duration: 5000,
        // 		} as ElNotificationOptions;
        // 		Notification.success(message);
        // 	})
        // 	.catch((error) => {
        // 		const message: ElNotificationOptions = {
        // 			title: this.helper.toString(error),
        // 			duration: 5000,
        // 		} as ElNotificationOptions;
        // 		Notification.error(message);
        // 	});
      }
    }
  }, {
    key: "cleanZoneUpload",
    value: function cleanZoneUpload() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      return this.helper.cleanDataRemoveNull({
        project: this.projectCodeId,
        zones: data.map(function (datavalue, indexvalue) {
          datavalue['code'] = "ZONE".concat(indexvalue + 1);
          return datavalue;
        })
      });
    }
  }, {
    key: "submitZoneInformation",
    value: function submitZoneInformation() {
      var _this8 = this;

      var mapWorld = this.$refs.mapWorld;

      if (typeof mapWorld !== 'undefined' && this.locationData && this.helper.isNotEmpty(this.projectCodeId) && this.helper.isNotEmpty(this.locationId)) {
        var cleanData = this.cleanZoneInfrormation(this.locationData);
        var duplicateLocation = this.locationList.find(function (lData) {
          return lData['_id'] !== _this8.locationId && lData['code'] === cleanData['code'];
        });

        if (duplicateLocation) {
          var message = {
            title: this.$i18n.t('notification.zone.duplicateCode'),
            duration: 5000
          };

          _elementUi.Notification.error(message);

          return;
        }

        this.logger.info("one form submitted: ".concat(JSON.stringify(cleanData)));
        this.request.put('AI_ROUTE', "zoning/".concat(this.locationId), this.requestParameters, cleanData).then(function (data) {
          if (data.failed) {
            return Promise.reject(data.message || '');
          }

          _this8.onChangeProjectCodes();

          _this8.updateZoneModal = false;
          var message = {
            title: _this8.$i18n.t('notification.zone.updateSuccess'),
            duration: 5000
          };

          _elementUi.Notification.success(message);

          _this8.clearRoutingCache();
        }).catch(function (error) {
          var message = {
            title: _this8.$i18n.t('notification.zone.error'),
            duration: 5000
          };

          _elementUi.Notification.error(message);
        });
      }
    }
  }, {
    key: "cleanZoneInfrormation",
    value: function cleanZoneInfrormation() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return this.helper.cleanDataRemoveNull({
        code: data['code'].toUpperCase(),
        name: data['name'] || '',
        color: data['color'] || this.helper.randomColor,
        description: data['description'] || ''
      });
    }
  }, {
    key: "submitCopyForm",
    value: function submitCopyForm() {
      var _this9 = this;

      var mapWorld = this.$refs.mapWorld;

      if (typeof mapWorld !== 'undefined' && this.helper.isNotEmpty(this.projectCodeId)) {
        var cleanData = this.cleanCopyFormData();
        this.logger.info("copy form submitted: ".concat(JSON.stringify(cleanData)));
        this.request.post('AI_ROUTE_V2', 'zoning-copy', this.requestParameters, cleanData).then(function (data) {
          if (data.failed) {
            return Promise.reject(data.message || '');
          }

          _this9.copyProjectCodeId = '';
          _this9.copyZoneModal = false;
          var message = {
            title: _this9.$i18n.t('notification.zone.copySuccess'),
            duration: 5000
          };

          _elementUi.Notification.success(message);

          _this9.clearRoutingCache();
        }).catch(function (error) {
          var message = {
            title: _this9.$i18n.t('notification.zone.error'),
            duration: 5000
          };

          _elementUi.Notification.error(message);
        });
      }
    }
  }, {
    key: "cleanCopyFormData",
    value: function cleanCopyFormData() {
      return this.helper.cleanDataRemoveNull({
        projectFrom: this.projectCodeId,
        projectTo: this.copyProjectCodeId
      });
    }
  }, {
    key: "refreshMap",
    value: function refreshMap() {
      var _this10 = this;

      var mapWorld = this.$refs.mapWorld;

      if (typeof mapWorld !== 'undefined' && this.helper.isNotEmpty(this.projectCodeId) && this.helper.isNotEmpty(this.locationId)) {
        this.request.get('ROUTING', "v1/core/zone/".concat(this.locationId), this.requestParameters).then(function (data) {
          if (data.failed) {
            return Promise.reject(data.message || '');
          }

          if (data.data && data.data.wayPoints) {
            _this10.locationData = data.data;

            if (data.data.wayPoints.length >= 3) {
              // mapWorld.initPolygon(data.data.wayPoints, this.locationData['color']);
              mapWorld.initPolygonWithOverlay({
                locations: data.data.wayPoints,
                currZoneId: data.data._id,
                locationList: _this10.locationList,
                color: _this10.locationData['color']
              });
            } else {
              // mapWorld.drawPolygon(this.locationData['color']);
              mapWorld.drawPolygonWithOverlay({
                locationList: _this10.locationList,
                color: _this10.locationData['color']
              });
            }
          }
        }).catch(function (error) {
          var message = {
            title: _this10.helper.toString(error),
            duration: 5000
          };

          _elementUi.Notification.error(message);
        });
      } else {
        this.request.get('ROUTING', 'v1/core/zones/', _objectSpread(_objectSpread({}, this.requestParameters), {
          exactQuery: true,
          query: "project:".concat(this.projectCodeId)
        })).then(function (data) {
          if (data.failed) {
            return Promise.reject('');
          }

          _this10.locationList = data.data ? [{
            _id: '',
            code: _this10.$i18n.t('zone.showAll'),
            color: '#ffffff'
          }].concat((0, _toConsumableArray2.default)(data.data)) : [{
            _id: '',
            code: _this10.$i18n.t('zone.showAll'),
            color: '#ffffff'
          }];
          mapWorld.initAllPolygon(_this10.locationList);
        }).catch(function (error) {
          _this10.locationList = [{
            _id: '',
            code: _this10.$i18n.t('zone.showAll'),
            color: '#ffffff'
          }];
          mapWorld.initAllPolygon(_this10.locationList);
        });
      }
    }
  }, {
    key: "exportZone",
    value: function exportZone() {
      var _this11 = this;

      if (this.projectCodeId === '' || this.projectCodeId === null) {
        return;
      }

      var cleanData = {
        projectCode: this.projectCodeId
      };
      var exportUrl = 'v1/core/zone/export'; // HACK: for wellcome pns

      if (this.isWellcome) {
        exportUrl = 'v1/core/zone/export/wellcome';
      }

      if (this.isPns) {
        exportUrl = 'v1/core/zone/export/pns';
      }

      this.request.postFile('ROUTING', exportUrl, _objectSpread({}, this.requestParameters), cleanData).then(function (data) {
        if (data.failed) {
          return Promise.reject(data.message.message || '');
        }

        if (_this11.isWellcome || _this11.isPns) {
          _this11.helper.downloadFile(data, "zone-export-".concat(_this11.projectCodeId, "-").concat(_this11.helper.ymdToString(new Date())), 'json');
        } else {
          _this11.helper.downloadFile(data, "zone-export-".concat(_this11.projectCodeId, "-").concat(_this11.helper.ymdToString(new Date())), 'csv');
        }
      }).catch(function (error) {
        var message = {
          title: _this11.helper.toString(error),
          duration: 5000
        };

        _elementUi.Notification.error(message);
      });
    }
  }, {
    key: "clearRoutingCache",
    value: function clearRoutingCache() {
      var _this12 = this;

      if (process.env.NODE_ENV !== 'poroduction') {
        return;
      }

      return this.request.post('ROUTING', 'v1/noauth/clearcache', (0, _defineProperty2.default)({}, process.env.VUE_APP_CUSTOMER_KEY, process.env.VUE_APP_CUSTOMER_KEY_HASH)).then(function (cacheData) {
        return _this12.logger.info(cacheData);
      }).catch(function (error) {
        return _this12.logger.error(error);
      });
    }
  }]);
  return ZoneV2Component;
}((0, _vuePropertyDecorator.Mixins)(_permission.PermissionMixin, _helper.HelperMixin, _logger.LoggerMixin, _loading.LoadingMixin, _autoLogout.AutoLogoutMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('userSetting', {
  namespace: 'authentication'
})], ZoneV2Component.prototype, "$userSetting", void 0);
(0, _tslib.__decorate)([(0, _vuexClass.Getter)('lfToken', {
  namespace: 'authentication'
})], ZoneV2Component.prototype, "$lfToken", void 0);
ZoneV2Component = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'ZoneV2Component',
  components: {
    'map-world': _mapWorld.default,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-dialog': _elementUi.Dialog,
    'el-tooltip': _elementUi.Tooltip,
    'el-select': _elementUi.Select,
    'el-option': _elementUi.Option,
    'el-form': _elementUi.Form,
    'el-form-item': _elementUi.FormItem,
    'el-button': _elementUi.Button,
    'el-input': _elementUi.Input,
    'el-button-group': _elementUi.ButtonGroup,
    'el-color-picker': _elementUi.ColorPicker,
    'el-input-number': _elementUi.InputNumber
  }
})], ZoneV2Component);
var _default = ZoneV2Component;
exports.default = _default;